<template lang="pug">
    img(
        src="../assets/catskill_creek.jpg"
        class="img-fluid"
    )
</template>
<script>
export default {
  props: {
    imageSrc: String
  }
};
</script>
